"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactOtpInput = _interopRequireDefault(require("react-otp-input"));
require("./CustomOtpInput.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CustomOtpInput = function CustomOtpInput(_ref) {
  var otpVal = _ref.otpVal,
    onChangeOtp = _ref.onChangeOtp,
    otpCount = _ref.otpCount,
    newContainerStyle = _ref.newContainerStyle,
    newInputStyle = _ref.newInputStyle,
    seperatorStyle = _ref.seperatorStyle;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cust-otp-input-container"
  }, /*#__PURE__*/_react.default.createElement(_reactOtpInput.default, {
    containerStyle: _objectSpread({
      marginTop: 10,
      display: 'flex',
      justifyContent: 'space-between',
      width: 300,
      borderColor: '#BFC1C4'
    }, newContainerStyle),
    inputStyle: _objectSpread({
      borderRadius: 10,
      height: 54,
      width: 42,
      borderWidth: 2,
      borderColor: '#BFC1C4'
    }, newInputStyle),
    value: otpVal,
    onChange: onChangeOtp,
    numInputs: otpCount,
    renderSeparator: /*#__PURE__*/_react.default.createElement("span", {
      style: seperatorStyle
    }),
    renderInput: function renderInput(props) {
      return /*#__PURE__*/_react.default.createElement("input", props);
    }
  }));
};
var _default = CustomOtpInput;
exports.default = _default;